<template>
  <div>
    <b-sidebar
      id="sidebar-condition"
      ref="sidebarCondition"
      v-model="isShowSidebar"
      aria-labelledby="sidebar-condition-header"
      right
      backdrop
      shadow
      no-header
      width="80vw"
    >
      <div class="px-3">
        <b-row class="header-filter">
          <b-col class="text-filter"> Conditions </b-col>
          <b-col class="text-right">
            <button class="btn-clear" @click.prevent="hide">x</button>
          </b-col>
        </b-row>
        <div v-if="isLoading">
          <OtherLoading />
        </div>
        <div v-else>
          <div class="mt-3">
            <b-form-radio-group v-model="formInput.is_limit">
              <b-row>
                <b-col
                  ><b-form-radio :value="0">Unconditional</b-form-radio></b-col
                >
                <b-col><b-form-radio :value="1">Custom</b-form-radio></b-col>
              </b-row>
            </b-form-radio-group>
          </div>
          <div v-if="formInput.is_limit == 1" class="mt-2">
            <b-row>
              <b-col md="6">
                <InputText
                  textFloat="Number Of Message"
                  placeholder=""
                  type="number"
                  name="number_message"
                  v-model="formInput.user_limit_times"
              /></b-col>
              <b-col md="6">
                <InputText
                  textFloat="Number Of Days"
                  placeholder=""
                  type="number"
                  v-model="formInput.user_limit_days"
                  name="number_days"
              /></b-col>
            </b-row>
          </div>
        </div>
      </div>
      <template #footer>
        <div class="d-flex justify-content-between shadow align-items-center">
          <div class="w-100">
            <b-button
              block
              variant="dark"
              class="text-light rounded-pill"
              @click="hide"
              :disabled="isLoading"
            >
              Cancel
            </b-button>
          </div>
          <div class="w-100">
            <b-button
              block
              variant="light"
              :disabled="isLoading"
              class="text-body rounded-pill btn-main"
              @click.prevent="$emit('settingCondition', formInput)"
            >
              Save
            </b-button>
          </div>
        </div>
      </template>
    </b-sidebar>
  </div>
</template>

<script>
import InputSelectAutomation from "@/components/inputs/InputSelectAutomation";
import UploadFileSendMessage from "@/components/automation/segmentation/UploadFileSendMessage";
import OtherLoading from "@/components/loading/OtherLoading";
export default {
  components: {
    InputSelectAutomation,
    UploadFileSendMessage,
    OtherLoading,
  },
  props: {
    form: {
      required: true,
      type: Object,
    },
    v: {
      required: false,
      type: Object,
    },
    selected: {
      required: true,
      type: Number,
    },
  },
  data() {
    return {
      isShowSidebar: false,
      condition_type_id: 0,
      noPleaseSelect: true,
      isSelected: this.form.is_limit,
      styleDatetime: {
        width: "100%",
        border: "none",
      },
      filename: "",
      fileBase64: "",
      isLoading: false,
      type: 0,
      formInput: {
        is_limit: 0,
        user_limit_days: 0,
        user_limit_times: 0,
      },
    };
  },
  methods: {
    show() {
      let form = { ...this.form };
      this.formInput = {
        is_limit: form.is_limit,
        user_limit_days: form.user_limit_days,
        user_limit_times: form.user_limit_times,
      };
      this.isShowSidebar = true;
    },
    hide() {
      this.isShowSidebar = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.header-filter {
  background-color: var(--secondary-color);
  padding: 15px 0;
}
.text-filter {
  color: var(--font-color);
  font-weight: 600;
}
.btn-clear {
  background-color: transparent;
  border: none;
}
::v-deep .input-group-text {
  background-color: #fff;
  padding: 0 0.75rem;
}

::v-deep .b-sidebar {
  width: 450px;
}
::v-deep .b-sidebar > .b-sidebar-body {
  overflow-x: hidden;
}
::v-deep .b-sidebar > .b-sidebar-header {
  font-size: 16px;
  display: block;
  padding: 0 1rem;
}
.bg-color {
  background-color: var(--primary-color);
}
.btn-add {
  background-color: transparent;
  border: none;
  color: var(--primary-color);
}
.add-new {
  text-decoration: underline;
}
::v-deep .btn-light {
  background-color: transparent;
  border: none;
}
.display-inline {
  display: inline-block;
}
::v-deep .btn-secondary {
  background-color: #fff;
  border-color: #fff;
}
::v-deep .rounded-pill {
  border-radius: 0px !important;
}
::v-deep .btn-main,
.btn-mains button {
  width: 100% !important;
  background-color: var(--primary-color) !important;
  border: 1px solid var(--primary-color);
}
.text-error {
  color: red;
}
.border-error {
  border-color: red;
}

.icon-primary {
  flex: 1 1 auto;
  cursor: text;
}
::v-deep .date-picker .vdatetime-input {
  margin-bottom: 0;
  padding: 2px 10px;
}
</style>
